export default __webpack_public_path__ + "static/icon-tile-pairing-dont-46af6cd85394fd1afa53d7bb23d2490c282561382a67a5b5936958abb781f6b3.png";